import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/authcontext";
import { useNavigate, useLocation } from "react-router-dom";
import LoginComponent from "./LoginComponent";
import { loginUser } from "../../utils/authApiHelpers";

function LoginContainer() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { login, auth } = useAuth();
    const location = useLocation();
    const from = location.state?.from?.pathname || null;

    useEffect(() => {
        if (auth.isAuthenticated && from === null) {
            navigate("/dashboard");
        }
    }, [auth.isAuthenticated, from, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await loginUser({ email, password }, login);
            navigate("/dashboard");
        } catch (err) {
            if (err.response?.status === 401) {
                setError(err.response?.data?.error || "Ongeldige inloggegevens. Probeer het opnieuw.");
            } else if (err.response?.status === 500) {
                setError(err.response?.data?.error || "Er is iets misgegaan bij het inloggen.");
            }
        }
    };

    return (
        <LoginComponent
            email={email}
            password={password}
            error={error}
            onEmailChange={(e) => setEmail(e.target.value)}
            onPasswordChange={(e) => setPassword(e.target.value)}
            onSubmit={handleSubmit}
        />
    );
}

export default LoginContainer;

LoginContainer.propTypes = {
    // No props
};
